import { TranslatePipe } from '../../filters/translate.pipe';
import {Component, OnInit, inject} from '@angular/core';
import { CommonModule } from '@angular/common';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import { RouterLink } from '@angular/router';

@Component({
    standalone: true,
    selector: 'modal-success-survey-creation',
    templateUrl: './modal-success-survey-creation.component.html',
    imports: [CommonModule, TranslatePipe, RouterLink]
})
export class ModalSuccessSurveyCreationComponent implements OnInit {
    private dialogRef = inject(MatDialogRef<ModalSuccessSurveyCreationComponent>);
    private data = inject(MAT_DIALOG_DATA);

    vm: any = undefined;

    constructor() {
        this.vm = this;
    }

    ngOnInit() {
        Object.keys(this.data || {}).forEach(key => this.vm[key] = this.data[key]);
        this.vm.returnPath = this.vm.returnPath || '/employee-surveys';
        this.vm.returnLabel = this.vm.returnLabel || undefined;
        this.vm.close = this.close;
    }


    close() {
        this.dialogRef.close(undefined);
    }

}
